import { makeAutoObservable, runInAction } from "mobx";
import { exportPatientDataRawList } from "../../ExportDataService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import i18n from "i18n";
import moment from "moment";

export default class M5Store {
    m5Data = null;
    totalElements = 0;
    totalPages = 0;
    page = 1;
    rowsPerPage = 5;
    keyword = "";
    loadingInitial = false;
    shouldOpenEditorDialog = false;
    shouldOpenConfirmationDialog = false;
    shouldOpenConfirmationDeleteListDialog = false;
    searchObject = {
        fromDate: new Date(new Date().getFullYear(), 0, 1),
        toDate: new Date(),
        watchBy: 3,
        currentRegion: null,
        currentProvince: null,
        currentUnit: null,
    };
    constructor() {
        makeAutoObservable(this);
    }

    setLoadingInitial = (state) => {
        this.loadingInitial = state;
    };

    handleSetSearchObject = (item) => {
        if (item.pageIndex) {
            this.page = item.pageIndex;
        }
        this.searchObject = item;
    };

    handleExportExcel = (item) => {
        var searchObj = {
            fromDate: item?.fromDate,
            toDate: item?.toDate,
            watchBy: item?.watchBy,
            orgId: item.currentUnit?.id,
            regionId: item.currentRegion?.id,
            provinceId: item.currentProvince?.id,
            departmentId: item?.department?.id,
        };
        exportPatientDataRawList(searchObj)
            .then((res) => {
                // debugger
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    "DU-LIEU-THO-" 
                    + moment(new Date()).format("DDMMYYYY-HHmm")
                    + ".xlsx"
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.log(error);
                toast.warning(i18n.t("toast.error"));
            });
    };
}
